._ResponsiveGrid_vug5c_1 {
  position: relative;
}
._ResponsiveGrid_vug5c_1 ._itemWrapper_vug5c_4 {
  position: absolute;
  box-sizing: border-box;
  will-change: transform, width, height, opacity;
}